import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=9e2eb370&lang=pug&"
import script from "./Support.vue?vue&type=script&lang=ts&"
export * from "./Support.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports